import request from './request'
import * as http from '@/libs/http'

/**
 * 予約情報を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Number} rid 予約ID
 * @returns {Response} レスポンスデータ
 */
export function cancelReserve (uid, rid) {
  return request.delete(`/users/${uid}/reserves/${rid}`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
